import clsx from 'clsx';
import React from 'react';
import { AccordionProvider } from './AccordionContext';
import { AccordionDetails } from './AccordionDetails';
import { AccordionSummary } from './AccordionSummary';
import { AccordionWrapper } from './AccordionWrapper';

import type { AccordionProps } from './Accordion.types';

/**
 * Base accordion exported as `Accordion`
 */
const AccordionBase = React.forwardRef<HTMLElement, AccordionProps>(
  (
    {
      as: Component = 'div',
      children,
      className,
      initialOpen = false,
      theme,
      testId,
      style,
    },
    ref
  ): JSX.Element => {
    return (
      <AccordionProvider initialOpen={initialOpen}>
        <Component
          ref={ref}
          className={clsx('hg-accordion', className)}
          data-theme={theme}
          data-testid={testId}
          style={style}
        >
          {children}
        </Component>
      </AccordionProvider>
    );
  }
);
AccordionBase.displayName = 'Accordion';

/**
 * Exports `Accordion`, `Accordion.Wrapper`, `Accordion.Summary`, `Accordion.Details`
 */
export const Accordion = Object.assign(AccordionBase, {
  Wrapper: AccordionWrapper,
  Summary: AccordionSummary,
  Details: AccordionDetails,
});
